import { create } from "zustand";

type UseModalInformacionReingresoSerieStoreState = {
  open: boolean;
  setOpen: (open: boolean) => void;

  serie: string | null;
  setSerie: (serie: string | null) => void;
}

export const useModalInformacionReingresoSerieStore = create<UseModalInformacionReingresoSerieStoreState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  serie: null,
  setSerie: (serie) => set({ serie }),
}))